<template>
  <div class="product product-grid">
    <div class="product-media table-wrap">
      <div class="product-thumbnail table-cell">
        <a :href="selected.url" :title="selected.name">
          <img :src="selected.thumb" class="current" />
        </a>
      </div>
      <!-- /.product-thumbnail -->
      <span v-if="selected.discount > 0 && !category" class="product-label sale"><span>sale</span></span>
      <span v-if="selected.discount > 0" class="product-label hot"><span class="percentage">{{ selected.discount }}%OFF</span></span>
      <!-- start of member discount-->
      <span class="product-label sold" :class="{hide:selected.has_stock}">SOLD OUT</span>

      <span v-if="selected.specialevent <= 0 && selected.discount > 0 && category" class="product-label" :class="category"><span v-text="category"></span></span>

      <span v-if="selected.specialevent > 0" class="product-label specialevent"><span>期間優惠</span></span>
      <!-- end of member discount-->
    </div>

    <div class="product-body">
      <div class="awe-media-body center">
        <h3 class="product-brand">
          <a :href="'product/brand?code=' + product.brand.code" v-text="product.brand.name"></a>
        </h3>
        <h2 class="product-name">
          <a :href="'product/details?code=' + product.code" :title="product.description" v-on:click="
              ga(
                'send',
                'event',
                product.brank.name,
                '產品',
                product.description
              )
            ">
            {{ selected.description }} {{ selected.color }}
          </a>
        </h2>
        <h2 class="product-code">
          <a :href="'product/details?code=' + product.code" :title="product.description" v-on:click="
              ga(
                'send',
                'event',
                product.brank.name,
                '產品',
                product.description
              )
            ">
            {{ selected.productcolor_code }}
          </a>
        </h2>
      </div>
      <div v-if="selected.hide_price <= 0" class="product-price text-center" :class="selected.discount ? 'discount' : ''">
        <span class="amount"> $ {{ selected.price }} </span>

        <del class="amount" v-if="selected.discount">$ {{ selected.retail_price }}</del>
      </div>
      <div class="thumb-container">
        <ul>
          <li v-for="(pc, index) in product.productcolors" @click="onClickThumb(pc)" :key="index">
            <div class="table-wrap">
              <div class="table-cell">
                <img :src="pc.thumb_small" :title="pc.code + ' ' + pc.color" />
                <div class="discount-percent" v-if="pc.discount > 0" v-text="pc.discount + '% Off'"></div>
                <div class="discount-percent" v-if="pc.discount <= 0">
                  &nbsp;
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>

      <!-- /.awe-media-body -->
    </div>
  </div>
</template>

<script>
  export default {
    name: "product-grid",
    props: {
      product: Object,
      member: {
        type: Object,
        default: function () {
          return {};
        },
      },
    },
    data: function () {
      return {
        selected: {},
        category: null,
      };
    },
    created: function () {
      this.selected = this.product.productcolors[0];
      this.member.then(
        function () {
          if (!this.member.isExpired() && this.member.category) {
            this.category = this.member.category.toLowerCase();
          }
        }.bind(this)
      );
    },
    mounted: function () {
      $(".thumb-container").mCustomScrollbar();
    },
    watch: {
      product: function () {
        this.selected = this.product.productcolors[0];
      },
    },
    methods: {
      onClickThumb: function (pc) {
        this.selected = pc;
        ga("send", "event", pc.brand.name, "轉換顏色", pc.name + " " + pc.color);
      },
    },
  };
</script>